import { Component } from '@angular/core';
import { CMSContentService } from '../../essentials/cms/content/cms-content.service';

@Component({
  selector: 'fcp-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss']
})
export class LogoComponent {
  public img;

  constructor(private cmsContentService: CMSContentService) {
    this.cmsContentService.return('logo').subscribe(response => {
      this.img = response.items[0].data.Imagem.iv[0];
    });
  }
}
